import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { UnderUiModule } from "@app/under-ui.module";

platformBrowserDynamic()
  .bootstrapModule(UnderUiModule, { ngZoneEventCoalescing: true })
  .catch((error) => console.error(error))
